import React, {memo} from "react";
import styles from "./styles.module.scss";
import Space from "@/app/components/space";
import IconButton from "@/app/components/icon_button";
import LazyAssets from "@/app/utils/assets_widget";
import {TextMedium14} from "@/app/components/texts";
import {t} from "i18next";
import {useNavigate} from "react-router-dom";

export enum BreadcrumbsType {
  padel = "padel",
  chats = "chats",
  findPlayers = "findPlayers",
  map = "map",
  profile = "profile",
  createAMatch = "createAMatch",
  matches = "matches",
  matchDetail = "matchDetail",
}

interface BreadcrumbsProps {
  items?: Array<BreadcrumbsType | string>;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
                                                   items = [BreadcrumbsType.padel],
                                                 }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.breadcrumbs}>
      <IconButton icon={<LazyAssets.Back/>} onClick={() => navigate(-1)}/>
      <Space.W16/>
      <div className={styles.items}>
        {items.map((item, index) => {
          return (
            <div key={index} className={styles.itemsWrapper}
                 onClick={() => (index - items.length) + 1 === 0 ? {} : navigate((index - items.length) + 1)}>
              <TextMedium14 text={t(item)}/>
              {index < items.length - 1 && (
                <TextMedium14 text="/" key={`sep-${index}`}/>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default memo(Breadcrumbs);